import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Button, styled } from '@mui/material';

const StyledInactiveTitle = styled(DialogTitle)`
  color: #70797b;
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: 1.5rem;
  font-weight: 700;
  text-align: left;
  margin-left: -25px;
`;
const StyledSubTitle = styled(DialogContentText)`
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: 1rem;
  font-weight: 500;
  text-align: left;
  margin-bottom: 1rem;
  white-space: pre-wrap;
`;
const StyledDialogActions = styled(DialogActions)`
  justify-content: center;
`;

const StyledDialog = styled(Dialog)``;

export default function DeleteDialog({
  open,
  setOpen,
  deleteFunction,
  title,
  isExclusao = true,
  isConfirmacao = false,
  id
}) {
  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseDelete = () => {
    deleteFunction(id);
    setOpen(false);
  };

  return (
    <StyledDialog open={open} onClose={handleClose}>
      <DialogContent>
        <StyledInactiveTitle>
          {isConfirmacao
            ? 'Confirmação'
            : 'Confirmação de ' + (isExclusao ? 'Exclusão' : 'Ativação')}
        </StyledInactiveTitle>
        <StyledSubTitle id="alert-dialog-description">{title}</StyledSubTitle>

        <StyledDialogActions>
          <Button color={'secondary'} variant={'text'} onClick={handleClose}>
            Cancelar
          </Button>
          <Button
            color={'primary'}
            variant={'contained'}
            onClick={handleCloseDelete}
          >
            Confirmar
          </Button>
        </StyledDialogActions>
      </DialogContent>
    </StyledDialog>
  );
}
